export const PURCHASE_GIFT_CARD_ROUTE = '/purchase-gift-card';
export const GIFT_CARD_TOP_UP_ROUTE = '/gift-card-top-up';
export const MEMBER_MONEY_ROUTE = '/member-money';

export const OTHERS_FIELDS_ROUTE = `${PURCHASE_GIFT_CARD_ROUTE}/others/fields`;
export const OTHERS_PAYMENT_ROUTE = `${PURCHASE_GIFT_CARD_ROUTE}/others/payment`;

export const SELF_FIELDS_ROUTE = `${PURCHASE_GIFT_CARD_ROUTE}/self/fields`;
export const SELF_PAYMENT_ROUTE = `${PURCHASE_GIFT_CARD_ROUTE}/self/payment`;

export const GIFT_CARD_TOP_UP_FIELDS_ROUTE = `${GIFT_CARD_TOP_UP_ROUTE}/fields`;
export const GIFT_CARD_TOP_UP_PAYMENT_ROUTE = `${GIFT_CARD_TOP_UP_ROUTE}/payment`;

export const MEMBER_MONEY_FIELDS_ROUTE = `${MEMBER_MONEY_ROUTE}/fields`;
export const MEMBER_MONEY_PAYMENT_ROUTE = `${MEMBER_MONEY_ROUTE}/payment`;
